<template>
  <div :class="$style.mobileMenu">
    <article>
      <router-link
        v-for="(link, index) in navLinks"
        :key="index"
        :to="{ name: link.name }"
        @click="onClose"
      >
        {{ $t(`navigation:menu.${link.title}`) }}
      </router-link>

      <div v-if="isSignedIn">
        <h4 class="px-4">
          {{ store.activeUsername }}
        </h4>
        <ul>
          <li v-for="link in accountMenuLinks" :key="link.label">
            <component
              :is="'CButton'"
              variant="menu"
              iconBefore
              v-bind="omit(link, ['on'])"
              v-on="link.on?.(onClose)"
            >
              {{ link.label }}
            </component>
          </li>
        </ul>
      </div>

      <NotificationMessages withCounter />
      <div class="flex items-center gap-2">
        <LangSelector class="flex items-center gap-2 ml-auto text-base" />
      </div>
    </article>
  </div>
</template>
<script setup lang="ts">
import { useActiveUserStore } from '@/stores/user';
import LangSelector from './LangSelector.vue';
import { useNavigation } from './composables';
import NotificationMessages from '@/components/elements/Notifications/NotificationMessages.vue';
import { omit } from '@/helpers/helpers';

defineProps<{ onClose(): void }>();

const store = useActiveUserStore();
const { navLinks, accountMenuLinks, isSignedIn } = useNavigation();
</script>
<style module>
@media (min-width: 580px) {
  .mobileMenu {
    display: none;
  }
}

.mobileMenu {
  position: fixed;
  inset: 0;
  background: var(--neutral-50);
  z-index: 2;
  padding: calc(var(--navbarHeight) + 1rem) 1rem 1rem;
  overflow: auto;

  a {
    text-decoration: none;
    color: var(--neutral-700);
    user-select: none;
  }

  > article {
    display: grid;
    gap: 1rem;
    font-size: 20px;
    height: 100%;

    > a {
      padding: 0 1rem;
    }
  }

  a:hover {
    color: var(--neutral-900);
  }

  :global(.router-link-active) {
    color: var(--neutral-800);
    font-weight: 600;
  }
}
</style>
